import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getNetsuiteIntegrationSettings = {
  name: "getNetsuiteIntegrationSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    settings: z
      .object({
        syncIncomingOrders: z.boolean().nullable(),
        sendUpdates: z.boolean().nullable(),
      })
      .nullable(),
  }),
};

export const syncNetsuiteItemFulfillment = {
  name: "syncNetsuiteItemFulfillment" as const,
  input: z.object({ teamId: zExt.objectId(), itemFulfillmentId: z.string() }),
  output: z.object({
    itemFulfillment: z.any().nullable(),
    error: z.string().nullable(),
    successfullyParsedItemFulfillment: z.boolean(),
    successfullyParsedFulfillmentOrder: z.boolean(),
    successfullyParsedLocation: z.boolean(),
    successfullyParsedInventoryItems: z.boolean(),
    successfullyParsedRedoFulfillment: z.boolean(),
    newFulfillmentGroupIds: z.array(zExt.objectId()).nullable(),
  }),
};
